import { DeveloperPortal } from "@/features/plugins/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/plugins/developer")({
	component: DeveloperPortalPage,
});

function DeveloperPortalPage() {
	return <DeveloperPortal />;
}
